import PasswordRuleItem from "../../../atoms/controls/validation/PasswordRuleItem";
import { useTranslation } from "react-i18next";

function checkRules(password) {
  return {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /\p{Ll}/u.test(password),
    digit: /[0-9]/.test(password),
    // eslint-disable-next-line no-useless-escape
    special: /[\^$*.{}\[\]()?"!@#%&/\\,><':;|_~`=+\-]/.test(password),
  };
}

export default function PasswordRuleList({ password = "" }) {
  const { t } = useTranslation();
  const rules = checkRules(password);

  return (
    password && (
      <div className="mb-4">
        <p className="text-gray-500 text-sm mb-1">
          {t("auth.password.createValidPassword")}
        </p>
        <ul className="mt-2 mb-1 ml-1">
          <PasswordRuleItem passed={rules.length}>
            <span>{t("auth.password.passwordLength")}</span>
          </PasswordRuleItem>
          <PasswordRuleItem passed={rules.upper}>
            <span>{t("auth.password.passwordUpper")}</span>
          </PasswordRuleItem>
          <PasswordRuleItem passed={rules.lower}>
            <span>{t("auth.password.passwordLower")}</span>
          </PasswordRuleItem>
          <PasswordRuleItem passed={rules.digit}>
            <span>{t("auth.password.passwordNumeric")}</span>
          </PasswordRuleItem>
          <PasswordRuleItem passed={rules.special}>
            <span>{t("auth.password.passwordSpecial")}</span>
          </PasswordRuleItem>
        </ul>
        <p className="text-gray-500 text-sm mb-1">
          {t("auth.password.needEnter")}
        </p>
      </div>
    )
  );
}
